/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./publish-custom-to-pt.vue?vue&type=template&id=c47330ba&"
import script from "./publish-custom-to-pt.vue?vue&type=script&lang=js&"
export * from "./publish-custom-to-pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports